import axios from 'axios'

const service = {
  // baseURL: 'http://cms.indea.cn:8081/qlwb', // api 的 base_url 測試
   baseURL: 'https://api.qiluyidian.mobi/qlwb', // api 的 base_url
  timeout: 15000, // request timeout
  headers: {'Content-Type': 'text/plain;charset=UTF-8'}
}
export default function request (req) {
  if (req.url) {
    let config = Object.assign({}, service, req)

    if (!config.params) {
      config.params = {}
    }

    config.params.timestamp = new Date().getTime()

    if (config.data.tokenID) {
      config.params.tokenID = config.data.tokenID
    }

    return new Promise((resole, reject) => {
      axios.request(config).then(res => {
        if (res.status !== 200) {
          reject(res)
        } else {
          resole(res)
        }
      }).catch(err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/common/js/request.js